import { TaskExecution } from '../processing/tasks/task-processing.model';
import { Hint } from '@sdbn/common';
export class GateKeepingCandidate {

  source: string;
  sourceId: string;
  company: string;
  name: string;
  numberPlate: string;
  hint: string;
  entranceAllowed: boolean;

  constructor(init?: Partial<GateKeepingCandidate>) {
    if (init != null) {
      this.source = init.source;
      this.sourceId = init.sourceId;
      this.company = init.company;
      this.name = init.name;
      this.numberPlate = init.numberPlate;
      this.hint = init.hint;
      this.entranceAllowed = init.entranceAllowed;
    }
  }
}

export class GateKeepingCase {

  candidate: GateKeepingCandidate;
  hints = new Array<Hint>();
  tasks = new Array<TaskExecution>();

  constructor(gateKeepingCase?: Partial<GateKeepingCase>) {
    if (gateKeepingCase != null) {
      if (gateKeepingCase.candidate != null) {
        this.candidate = new GateKeepingCandidate(gateKeepingCase.candidate);
      }
      if (gateKeepingCase.hints != null) {
        for (let hint of gateKeepingCase.hints) {
          this.hints.push(new Hint(hint));
        }
      }
      if (gateKeepingCase.tasks != null) {
        for (let task of gateKeepingCase.tasks) {
          this.tasks.push(new TaskExecution(task));
        }
      }
    }
  }

}

export class AreaGateReference {

  id: string;
  name: string;
  direction: string;

  constructor(reference?: Partial<AreaGateReference>) {
    if (reference != null) {
      this.id = reference.id;
      this.name = reference.name;
      this.direction = reference.direction;
    }
  }

}
